import { useState, useEffect } from "react";
import { TextField, Grid } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { Controller, useForm } from "react-hook-form";
import {
  PosTypeActions,
  resetForm,
  setDialog,
} from "../../../../app/slices/posType";
import { HiOutlineTag, HiOutlineDocumentText } from "react-icons/hi2";
import FormDialog, { SectionCard } from "../../../../components/FormDialog";

const PosTypeForm = () => {
  const dispatch = useDispatch();

  const _PosType = useSelector((state) => state.posType.posType);
  const _SearchBody = useSelector((state) => state.posType.searchBody);

  const [loading, setLoading] = useState(false);

  const isAdd = _PosType.form.id ? false : true;
  const { control, reset, handleSubmit } = useForm({
    defaultValues: _PosType.form,
  });

  const onSubmit = (data) => {
    setLoading(true);
    if (isAdd) {
      dispatch(
        PosTypeActions.create(
          {
            name: data.name,
            note: data.note,
          },
          _SearchBody
        )
      )
        .then((x) => setLoading(false))
        .catch((e) => setLoading(false));
    } else {
      dispatch(
        PosTypeActions.update(
          data.id,
          {
            name: data.name,
            note: data.note,
          },
          _SearchBody
        )
      )
        .then(() => setLoading(false))
        .catch((e) => setLoading(false));
    }
  };

  useEffect(() => {
    reset({ ..._PosType.form });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [_PosType.form]);

  useEffect(() => {
    return () => {
      dispatch(resetForm());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleDialog = () => {
    dispatch(setDialog());
  };

  return (
    <FormDialog
      open={_PosType.dialog}
      onClose={handleDialog}
      icon={<HiOutlineTag />}
      title={isAdd ? "إضافة فئة نقطة بيع" : "تعديل فئة نقطة البيع"}
      subtitle={
        isAdd
          ? "أدخل معلومات الفئة لإضافتها"
          : "قم بتحديث معلومات الفئة ثم احفظ التغييرات"
      }
      onSubmit={handleSubmit(onSubmit)}
      saving={loading}
      loading={_PosType.loading}
    >
      <SectionCard icon={<HiOutlineDocumentText />} title="معلومات الفئة">
        <Grid item xs={12}>
          <Controller
            name="name"
            control={control}
            render={({ field }) => (
              <TextField
                required
                size="small"
                label="الاسم"
                fullWidth
                {...field}
              />
            )}
          />
        </Grid>
      </SectionCard>
    </FormDialog>
  );
};

export default PosTypeForm;
